<template>
     <h2 class="fl-post-grid-title">
            <a
                :href="postObj.link"
                :target="hrefTarget"
            >
                {{postObj.title}}
            </a>
        </h2>
</template>

<script>
export default {
  props: {
    postObj: {
      type: Object
    },
    hrefTarget: {
      type: String
    }
  }
}
</script>
